import { render, staticRenderFns } from "./BookImage.vue?vue&type=template&id=0d51732d&"
import script from "./BookImage.vue?vue&type=script&lang=js&"
export * from "./BookImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports